module.exports = __webpack_public_path__ + "img/UI_shouji_BG_01_bd17af8a5.png";